export const SEARCH_PLACES = 'SEARCH_PLACES';
export const GET_PLACE = 'GET_PLACE';
export const CLEAR_PLACES = 'CLEAR_PLACES';
export const GET_WEATHER = 'GET_WEATHER';
export const STOP_LOADING = 'STOP_LOADING';
export const SET_LOADING = 'SET_LOADING';
export const CLEAR_WEATHER = 'CLEAR_WEATHER';
